import React from "react";
import { badgeTone } from "../lib/practiceApi";

export const StatusBadge = ({ status, testId, variant = "practice-badge" }) => {
  const label = String(status ?? "").trim();
  if (!label) return <span className="muted" data-testid={testId}>—</span>;
  return <span className={`${variant} ${badgeTone(label)}`} data-testid={testId}>{label}</span>;
};
